import { useEffect, useState } from 'react'
import { apiEtapa6 } from '../api'
import Aviso from '../../components/Aviso'
import { Campo, dataBR } from '../../etapa2/componentes'

const DIAS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']
const hoje = () => new Date().toISOString().slice(0, 10)

export default function Jornada({ empresaId }) {
  const [data, setData] = useState(hoje())
  const [vigente, setVigente] = useState(null)
  const [empresa, setEmpresa] = useState({ dias_repouso_semana: null, escala_12x36: false, sabado_repouso_por_norma: false })
  const [func, setFunc] = useState({ funcionario_id: '', horas_semanais_contratuais: '' })
  const [msg, setMsg] = useState({ erro: '', ok: '' })

  async function acao(fn, ok) {
    setMsg({ erro: '', ok: '' })
    try {
      const r = await fn()
      if (ok) setMsg({ erro: '', ok })
      return r
    } catch (e) {
      setMsg({ erro: e.message, ok: '' })
      return undefined
    }
  }

  useEffect(() => {
    apiEtapa6.jornadaVigente(data).then(setVigente).catch(() => setVigente(null))
  }, [data])
  useEffect(() => {
    if (!empresaId) return
    apiEtapa6.jornadaEmpresa(empresaId)
      .then((e) => setEmpresa({ dias_repouso_semana: e.dias_repouso_semana, escala_12x36: e.escala_12x36, sabado_repouso_por_norma: !!e.sabado_repouso_por_norma }))
      .catch(() => setEmpresa({ dias_repouso_semana: null, escala_12x36: false, sabado_repouso_por_norma: false }))
  }, [empresaId])

  const repouso = empresa.dias_repouso_semana ?? []
  const alternarDia = (d) => {
    const dias = repouso.includes(d) ? repouso.filter((x) => x !== d) : [...repouso, d].sort()
    setEmpresa({ ...empresa, dias_repouso_semana: dias.length ? dias : null })
  }
  async function carregarFuncionario() {
    const r = await acao(() => apiEtapa6.jornadaFuncionario(empresaId, func.funcionario_id))
    setFunc({ ...func, horas_semanais_contratuais: r?.horas_semanais_contratuais ?? '' })
  }

  return (
    <section>
      <h2>Jornada e escala</h2>
      <p className="fundamento">
        EC 141/2026: jornada máxima de 42 horas semanais com dois repousos remunerados a partir de 15/12/2026 (divisor 210) e
        40 horas a partir de 15/12/2027 (divisor 200), sem redução de salário. Jornadas contratuais menores não mudam.
      </p>
      <div className="grade">
        <Campo rotulo="Consultar a jornada vigente em"><input type="date" value={data} onChange={(e) => setData(e.target.value)} /></Campo>
      </div>
      {vigente && (
        <p className="fundamento">
          Desde {dataBR(vigente.inicio)}: <strong>{Number(vigente.horas_semanais_maximas)}h semanais</strong>, divisor {Number(vigente.divisor_mensal)},
          {' '}{vigente.repousos_semanais} repouso(s) semanal(is) · {vigente.fundamento}
        </p>
      )}

      <h3>Empresa</h3>
      <div className="grade">
        <Campo rotulo="Dias de repouso remunerado (vazio = padrão da vigência)">
          <div className="dias">
            {DIAS.map((n, d) => (
              <label className="inline" key={d}><input type="checkbox" checked={repouso.includes(d)} onChange={() => alternarDia(d)} /> {n}</label>
            ))}
          </div>
        </Campo>
        {repouso.includes(5) && repouso.length > 1 && (
          <Campo rotulo="Sábado até 14/12/2026 (lei com 1 repouso semanal)">
            <label className="inline">
              <input type="checkbox" checked={empresa.sabado_repouso_por_norma}
                onChange={(e) => setEmpresa({ ...empresa, sabado_repouso_por_norma: e.target.checked })} />
              {' '}Convenção/acordo coletivo trata o sábado como repouso remunerado
            </label>
            <small className="fundamento">
              Desmarcado (padrão): o sábado de folga é dia útil não trabalhado e não entra como repouso no DSR (Lei 605/49).
              A partir de 15/12/2026 (EC 141, 2 repousos) o sábado informado é repouso de qualquer forma.
            </small>
          </Campo>
        )}
        <label className="inline"><input type="checkbox" checked={empresa.escala_12x36} onChange={(e) => setEmpresa({ ...empresa, escala_12x36: e.target.checked })} /> Escala 12x36</label>
      </div>
      <div className="acoes">
        <button disabled={!empresaId} onClick={() => acao(() => apiEtapa6.salvarJornadaEmpresa(empresaId, empresa), 'Escala da empresa salva.')}>Salvar empresa</button>
      </div>

      <h3>Funcionário</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={func.funcionario_id} onChange={(e) => setFunc({ ...func, funcionario_id: e.target.value })} /></Campo>
        <Campo rotulo="Horas semanais do contrato (vazio = máximo legal)">
          <input type="number" step="0.5" min="1" max="44" value={func.horas_semanais_contratuais} onChange={(e) => setFunc({ ...func, horas_semanais_contratuais: e.target.value })} />
        </Campo>
      </div>
      <div className="acoes">
        <button className="secundario" disabled={!empresaId || !func.funcionario_id} onClick={carregarFuncionario}>Carregar</button>
        <button
          disabled={!empresaId || !func.funcionario_id}
          onClick={() => acao(() => apiEtapa6.salvarJornadaFuncionario(empresaId, func.funcionario_id, { horas_semanais_contratuais: func.horas_semanais_contratuais || null }), 'Jornada do funcionário salva.')}
        >Salvar funcionário</button>
      </div>
      <Aviso>{msg.erro}</Aviso>
      <Aviso tipo="ok">{msg.ok}</Aviso>
    </section>
  )
}
